import type React from "react";
import {memo} from "react";

import type {ListingGroup} from "../../models/listingGroup";
import {useUserContext} from "../../react/hooks/useUserContext";
import {Text} from "../ui/text";
import {VStack} from "../ui/vstack";

import ListingGroupItem from "./ListingGroupItem";

type Props = {
    listingGroups: ListingGroup[];
    className?: string;
    onPressListingGroup: (listingGroupID: string) => void;
};

const ListingGroupList: React.FC<Props> = ({listingGroups, className, onPressListingGroup}) => {
    const {visibleListings} = useUserContext();

    return (
        <VStack className={className} space="sm">
            <Text color="blueGray.800" variant="md">
                Listing Groups
            </Text>
            <VStack>
                {visibleListings.length > 0 && (
                    <ListingGroupItem id="all" label="All listings" onPress={onPressListingGroup} />
                )}
                {listingGroups.map(listingGroup => {
                    return (
                        <ListingGroupItem
                            key={listingGroup._id}
                            count={
                                "uniqueMessageRulesCount" in listingGroup
                                    ? Number(listingGroup.uniqueMessageRulesCount)
                                    : undefined
                            }
                            id={listingGroup._id}
                            label={listingGroup.name}
                            onPress={onPressListingGroup}
                        />
                    );
                })}
            </VStack>
        </VStack>
    );
};

export default memo(ListingGroupList);
